"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredColumnTree = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _reactRedux = require("react-redux");
var _reducer = require("../reducer.js");
var _prettify = require("../prettify.js");
var _settings = require("../settings.js");
var _renders = _interopRequireDefault(require("../renders"));
var _RenderSettingsWrapper = _interopRequireDefault(require("../EditColumnForm/RenderSettingsWrapper.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Fortress = window.cccisd.fortress;
var getCurrentAction = (0, _memoize2["default"])(function (handle) {
  return _renders["default"].find(function (item) {
    return item.handle === handle;
  });
});
var getFilteredColumnTree = exports.getFilteredColumnTree = function getFilteredColumnTree(search, columnTree) {
  var result = (0, _cloneDeep2["default"])(columnTree);
  search = search.toLowerCase();
  function filterTree(node) {
    if (node.children) {
      node.children = node.children.filter(filterTree);
      return node.children.length > 0;
    }
    return (node.label || '').toLowerCase().includes(search);
  }
  return result.filter(filterTree);
};
var validate = function validate(values) {
  var errors = {};
  if (!values.query) {
    errors.query = 'Query is required';
  } else if (!(0, _prettify.isCorrectQuery)(values.query)) {
    errors.query = 'Wrong syntax or getting more than one field';
  }
  return errors;
};
var validateAction = function validateAction(values) {
  var errors = {};
  if (!values.render) {
    errors.render = 'Action is required';
  } else {
    var currentAction = getCurrentAction(values.render);
    if (currentAction.validateSettings && !(0, _isEmpty2["default"])(currentAction.validateSettings(values.renderSettings))) {
      errors.renderSettings = 'There are some errors in format settings';
    }
  }
  return errors;
};
var Component = function Component(props) {
  var usedColumns = props.usedColumns,
    tableSettings = props.tableSettings;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var expanded = (0, _reactRedux.useSelector)(function (state) {
    return state.tableEditor.expanded;
  });
  var columnTree = (0, _reactRedux.useSelector)(function (state) {
    return state.tableEditor.columnTree;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var filteredTree = (0, _react.useMemo)(function () {
    return getFilteredColumnTree(search, columnTree);
  }, [search, columnTree]);
  var actions = [{
    value: '',
    label: '-- Choose action --'
  }].concat(_toConsumableArray(_renders["default"].filter(function (item) {
    return item.isAction && (!item.applyToLevels || item.applyToLevels.includes(tableSettings.level));
  }).map(function (item) {
    return {
      value: item.handle,
      label: item.label
    };
  })));
  var traverse = function traverse(node, field, form) {
    if (node.children) {
      var isExpanded = expanded.includes(node.id) || !!search;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].header,
        onClick: function onClick() {
          return dispatch((0, _reducer.toggleExpanded)(node.id));
        }
      }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
        spaceRight: true
      }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
        spaceRight: true
      }), node.label), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].level
      }, node.children.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: child.id
        }, traverse(child, field, form));
      })));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "checkbox",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, usedColumns.has(node.id) && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].used
    }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      value: node.id,
      checked: node.id in field.value,
      onChange: function onChange(e) {
        form.setFieldValue(field.name, e.target.checked ? _objectSpread(_objectSpread({}, field.value), {}, _defineProperty({}, node.id, node)) : (0, _omit2["default"])(field.value, node.id));
      },
      disabled: usedColumns.has(node.id),
      style: usedColumns.has(node.id) ? {
        visibility: 'hidden'
      } : {}
    }), node.label));
  };
  var tabList = [{
    name: 'list',
    title: 'From list',
    content: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      key: "list",
      initialValues: {
        columns: {}
      },
      onSubmit: props.onSubmit,
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          name: "search",
          className: "form-control",
          placeholder: "search",
          style: {
            width: '10em'
          },
          autoFocus: true,
          autoComplete: "off",
          value: search,
          onChange: function onChange(e) {
            return setSearch(e.target.value);
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].content
        }, filteredTree.length === 0 ? 'No column found' : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns",
          render: function render(_ref) {
            var field = _ref.field,
              form = _ref.form;
            return filteredTree.map(function (item) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                key: item.id
              }, traverse(item, field, form));
            });
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttonArea
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary",
          type: "submit"
        }, "Add columns")));
      }
    }))
  }, {
    name: 'action',
    title: 'Action',
    content: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '1em'
      }
    }, actions.length === 1 ? /*#__PURE__*/_react["default"].createElement("div", null, "There is no action available") : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      key: "action",
      initialValues: {
        isAction: true,
        hideInCsv: true
      },
      validate: validateAction,
      onSubmit: props.onSubmit,
      render: function render(_ref2) {
        var values = _ref2.values,
          setValues = _ref2.setValues,
          setFieldValue = _ref2.setFieldValue,
          submitCount = _ref2.submitCount;
        var currentAction = getCurrentAction(values.render);
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "label",
          component: _cccisdFormik.CccisdInput,
          label: "Label",
          autoFocus: true
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-info",
          style: {
            paddingBottom: 0
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "render",
          component: _cccisdFormik.CccisdSelect,
          label: "Action",
          options: actions,
          style: {
            width: 'auto'
          },
          onChange: function onChange(e) {
            var render = e.target.value;
            var renderSettings = (_renders["default"].find(function (item) {
              return item.handle === render;
            }) || {}).initialSettings || {};
            setValues(_objectSpread(_objectSpread({}, values), {}, {
              render: render,
              renderSettings: renderSettings
            }));
          }
        }), currentAction && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          key: values.render,
          name: "renderSettings",
          render: function render(_ref3) {
            var field = _ref3.field,
              form = _ref3.form;
            return /*#__PURE__*/_react["default"].createElement(_RenderSettingsWrapper["default"], {
              showErrorsImmediately: submitCount > 0,
              initialValues: values.renderSettings,
              render: currentAction,
              onChange: form.setFieldValue.bind(null, 'renderSettings')
            });
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttonArea
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary",
          type: "submit"
        }, "Add column")));
      }
    }))
  }];
  if (Fortress.user.acting.is_super_user) {
    tabList.push({
      name: 'custom',
      title: 'Custom data',
      content: /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        key: "custom",
        initialValues: {
          type: 'string'
        },
        validate: validate,
        onSubmit: props.onSubmit,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "label",
            component: _cccisdFormik.CccisdInput,
            label: "Label",
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "query",
            component: _cccisdFormik.CccisdTextarea,
            label: "Query",
            style: {
              height: '10em'
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "type",
            component: _cccisdFormik.CccisdSelect,
            label: "Type",
            options: _settings.columnTypes,
            style: {
              width: 'auto'
            }
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].buttonArea
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add column")));
        }
      }))
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList
  });
};
Component.propTypes = {
  onSubmit: _propTypes["default"].func,
  usedColumns: _propTypes["default"].object,
  tableSettings: _propTypes["default"].object
};
Component.defaultProps = {
  usedColumns: new Set()
};
var _default = exports["default"] = Component;